var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16675 14.0406C4.51193 14.0406 4.79175 14.3204 4.79175 14.6656V16.3322C4.79175 16.4473 4.88502 16.5406 5.00008 16.5406H15.0001C15.1151 16.5406 15.2084 16.4473 15.2084 16.3322V14.6656C15.2084 14.3204 15.4882 14.0406 15.8334 14.0406C16.1786 14.0406 16.4584 14.3204 16.4584 14.6656V16.3322C16.4584 17.1377 15.8055 17.7906 15.0001 17.7906H5.00008C4.19467 17.7906 3.54175 17.1377 3.54175 16.3322V14.6656C3.54175 14.3204 3.82157 14.0406 4.16675 14.0406Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94829 13.9383C8.51964 13.9383 8.16206 13.6107 8.12463 13.1837C7.9966 11.7231 7.97401 10.2553 8.05699 8.79175C7.85117 8.78038 7.64544 8.7672 7.43979 8.75221L6.1985 8.66173C5.71992 8.62684 5.45238 8.0932 5.71076 7.68885C6.5958 6.30378 7.73619 5.09967 9.07116 4.14072L9.56846 3.78348C9.82638 3.59821 10.1738 3.59821 10.4317 3.78348L10.929 4.14072C12.264 5.09967 13.4043 6.30378 14.2894 7.68885C14.5478 8.0932 14.2802 8.62684 13.8016 8.66173L12.5604 8.75221C12.3547 8.7672 12.149 8.78038 11.9432 8.79175C12.0261 10.2553 12.0035 11.7231 11.8755 13.1837C11.8381 13.6107 11.4805 13.9383 11.0519 13.9383H8.94829Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.d4f0affdb98f3f199c0629a211f38bb0.svg";
export { ForwardRef as ReactComponent };